module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/icon.png","name":"Karo Hofmann – Sprecherin","short_name":"Karo Hofmann","description":"Meine Stimme für dein Projekt. Langjährige TV-Moderatorin, Newssprechering und Stationvoice aus Augsburg.","theme_color":"#ffffff","background_color":"#fde68a","display":"standalone","lang":"de","start_url":"/","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"be7625fe5230dc4d977832ad4b1e6c84"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
